import { LitElement, html } from "lit";
import { customElement } from "lit/decorators.js";
import { Auth } from "@saasbase-io/loginflow-websdk";
import { consume } from "@lit/context";
import { renderSpecContext } from "@/context";
import { waitForAuthConfigured } from "@/utils";

@customElement("sb-signup")
export class SbSignUp extends LitElement {
  @consume({ context: renderSpecContext, subscribe: true })
  renderSpec: string | null = null;

  createRenderRoot() {
    return this;
  }

  private __flowStarted = false;
  private __initialized = false;

  protected firstUpdated(): void {
    if (this.__initialized) return;
    this.__initialized = true;

    void this.startAuthFlow();
  }

  private async startAuthFlow() {
    await waitForAuthConfigured(Auth);

    if (this.__flowStarted) return;
    this.__flowStarted = true;

    try {
      const resp = await Auth.startLoginflow("sys_signup-flow");

      this.tryRemoveFallback();
    } catch (err: any) {
      console.error("[sb-signup] Auth failed:", err);
      this.__flowStarted = false;
    }
  }

  private tryRemoveFallback() {
    requestAnimationFrame(() => {
      const root = this as HTMLElement;

      const fallback = root.querySelector('[part="fallback"]');

      if (fallback) {
        fallback.remove();
      } else {
        console.warn("[sb-signup] fallback not found yet");
      }
    });
  }

  protected updated(changed: Map<string, unknown>) {
    if (changed.has("renderSpec") && this.renderSpec) {
      this.tryRemoveFallback();
    }
  }

  render() {
    if (!this.renderSpec) {
      return html``;
    }

    return html`<sb-layout .renderSpec=${this.renderSpec}></sb-layout>`;
  }
}
